<template>
    <div style="padding: 0px 3%;">
        
        <div>
            <el-divider content-position="left">
                <h2 style="color: #006E4B;">身份证</h2>
            </el-divider>
            <el-row style="margin-top: 20px;">
                <el-col :span="6" style="margin-bottom: 10px;">
                    <div style=" width: 90%; border: 1px solid #e9e9e9; border-radius: 5px; padding: 0 10px; height: 100px;">

                        <el-row>
                            <el-col :span="6" style="margin: 13px 0px;">
                                <!-- <img src="../../../../assets/icon/文件类型-附件@2x.png" width="65px" height="73px"/> -->
                                <!-- <img :src="from.staff_photo" style="float: right;" width="65px" height="73px" /> -->
                                <el-popover placement="top-start" trigger="click">
                                    <a :href="from.card_photo"  target="_blank" title="查看最大化图片">
                                    <img :src="from.card_photo" style="width: 800px;height: 500px">
                                    </a>
                                    <img slot="reference" :src="from.card_photo" style="width: 65px;height: 73px; cursor:pointer">
                                </el-popover>
                            </el-col>
                            <el-col :span="12" style="margin: 30px 0px;">
                                <span>{{from.staff_name}}-身份证附件.jpg</span>
                                <br />
                                <!-- <span style="font-size: 15px; color: #929292;">32kb</span> -->
                            </el-col>
                            <el-col :span="6" style="margin: 36px 0px;">
                                <!-- <el-button size="mini" style="background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="download(from.card_photo , from.staff_name + '-身份证附件' )">下载附件</el-button> -->
                            </el-col>
                        </el-row>

                    </div>
                </el-col>
                
            </el-row>



            <el-divider content-position="left">
                <h2 style="color: #006E4B;">银行卡</h2>
            </el-divider>
            <el-row style="margin-top: 20px;">
                <el-col :span="6" style="margin-bottom: 10px;">
                    <div style=" width: 90%; border: 1px solid #e9e9e9; border-radius: 5px; padding: 0 10px; height: 100px;">
                        <el-row>
                            <el-col :span="6" style="margin: 13px 0px;">
                                <!-- <img src="../../../../assets/icon/文件类型-附件@2x.png" width="65px" height="73px"/> -->
                                <!-- <img :src="from.staff_photo" style="float: right;" width="65px" height="73px" /> -->
                                <el-popover placement="top-start" trigger="click">
                                    <a :href="from.bank_photo"  target="_blank" title="查看最大化图片">
                                    <img :src="from.bank_photo" style="width: 800px;height: 500px">
                                    </a>
                                    <img slot="reference" :src="from.bank_photo" style="width: 65px;height: 73px; cursor:pointer">
                                </el-popover>
                            </el-col>
                            <el-col :span="12" style="margin: 30px 0px;">
                                <span>{{from.staff_name}}-银行卡附件.jpg</span>
                                <br />
                                <!-- <span style="font-size: 15px; color: #929292;">32kb</span> -->
                            </el-col>
                            <el-col :span="6" style="margin: 36px 0px;">
                                <!-- <el-button size="mini" style="background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="download(from.bank_photo , from.staff_name  + '-身份证附件')">下载附件</el-button> -->
                            </el-col>
                        </el-row>

                    </div>
                </el-col>
                
            </el-row>

        </div>
    
    </div>
</template>

<script>
    export default {
        props: ["from"],
    }
</script>

<style scoped="scoped">
</style>



// WEBPACK FOOTER //
// accessory.vue?6235e47a